import React, { useEffect, useState } from 'react';
import { adminService } from '../../services/api';

const STATUS = { trial: 'Trial', active: 'Ativa', past_due: 'Atrasada', canceled: 'Cancelada' };
const STATUS_COLOR = { trial: '#f59e0b', active: '#22c55e', past_due: '#ef4444', canceled: '#6b7280' };

const slugify = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export default function SaEmpresas() {
  const [tenants, setTenants] = useState([]);
  const [plans, setPlans] = useState([]);
  const [modal, setModal] = useState(null);   // {type:'new'|'edit', tenant?}
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  const load = async () => {
    const [t, p] = await Promise.all([adminService.getTenants(), adminService.getPlans()]);
    setTenants(t.data);
    setPlans(p.data);
  };
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ name: '', slug: '', plan_id: '', admin_name: '', admin_email: '', admin_password: '' }); setModal({ type: 'new' }); };
  const openEdit = (t) => {
    setForm({ name: t.name, plan_id: t.plan_id || '', subscription_status: t.subscription_status, is_active: t.is_active, mp_access_token: '', asaas_api_key: '' });
    setModal({ type: 'edit', tenant: t });
  };

  const handleCreate = async () => {
    if (!form.name || !form.admin_email || !form.admin_password) { alert('Nome, e-mail e senha do admin são obrigatórios'); return; }
    setLoading(true);
    try {
      await adminService.createTenant({ ...form, slug: form.slug || slugify(form.name), plan_id: form.plan_id || null });
      setModal(null); load();
    } catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };
  const handleUpdate = async () => {
    setLoading(true);
    try {
      const payload = { name: form.name, plan_id: form.plan_id || null, subscription_status: form.subscription_status, is_active: form.is_active ? 1 : 0 };
      // só envia chaves se preenchidas (não apaga o que já existe)
      if (form.mp_access_token) payload.mp_access_token = form.mp_access_token;
      if (form.asaas_api_key) payload.asaas_api_key = form.asaas_api_key;
      await adminService.updateTenant(modal.tenant.id, payload);
      setModal(null); load();
    } catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Empresas</h1>
          <p style={styles.sub}>{tenants.length} lan houses na plataforma</p>
        </div>
        <button style={styles.btnPrimary} onClick={openNew}>+ Empresa</button>
      </div>

      <div style={styles.grid}>
        {tenants.map(t => (
          <div key={t.id} style={styles.card}>
            <div style={styles.cardTop}>
              <div>
                <div style={styles.name}>{t.name}</div>
                <div style={styles.slug}>/{t.slug}</div>
              </div>
              <span style={{ ...styles.status, color: STATUS_COLOR[t.subscription_status], borderColor: STATUS_COLOR[t.subscription_status] }}>
                {STATUS[t.subscription_status] || t.subscription_status}
              </span>
            </div>
            <div style={styles.planRow}>
              <span style={styles.plan}>{t.plan_name || 'Sem plano'}</span>
              {t.price_monthly != null && <span style={styles.price}>R$ {Number(t.price_monthly).toFixed(2)}/mês</span>}
            </div>
            <div style={styles.metaRow}>
              <span>🖥️ {t.machines} máquinas</span>
              <span>👤 {t.operators} operador(es)</span>
            </div>
            <div style={styles.gateways}>
              <span style={{ ...styles.gwBadge, ...(Number(t.has_mp) ? styles.gwOn : styles.gwOff) }}>Mercado Pago</span>
              <span style={{ ...styles.gwBadge, ...(Number(t.has_asaas) ? styles.gwOn : styles.gwOff) }}>Asaas</span>
              {!t.is_active && <span style={styles.inactive}>inativa</span>}
            </div>
            <button style={styles.btnGhost} onClick={() => openEdit(t)}>Gerenciar</button>
          </div>
        ))}
      </div>

      {/* NOVA EMPRESA */}
      {modal?.type === 'new' && (
        <Overlay title="Nova Empresa">
          <Field label="Nome da lan house *"><input style={styles.input} value={form.name}
            onChange={e => setForm({ ...form, name: e.target.value, slug: slugify(e.target.value) })} /></Field>
          <Field label="Slug (identificador)"><input style={styles.input} value={form.slug}
            onChange={e => setForm({ ...form, slug: e.target.value })} /></Field>
          <Field label="Plano">
            <select style={styles.input} value={form.plan_id} onChange={e => setForm({ ...form, plan_id: e.target.value })}>
              <option value="">Selecione…</option>
              {plans.map(p => <option key={p.id} value={p.id}>{p.name} — R$ {Number(p.price_monthly).toFixed(2)}</option>)}
            </select>
          </Field>
          <div style={styles.divider}>Usuário administrador da empresa</div>
          <Field label="Nome do admin"><input style={styles.input} value={form.admin_name} onChange={e => setForm({ ...form, admin_name: e.target.value })} /></Field>
          <Field label="E-mail de login *"><input style={styles.input} value={form.admin_email} onChange={e => setForm({ ...form, admin_email: e.target.value })} /></Field>
          <Field label="Senha *"><input type="password" style={styles.input} value={form.admin_password} onChange={e => setForm({ ...form, admin_password: e.target.value })} /></Field>
          <Actions onCancel={() => setModal(null)} onSave={handleCreate} loading={loading} label="Criar empresa" />
        </Overlay>
      )}

      {/* GERENCIAR EMPRESA */}
      {modal?.type === 'edit' && (
        <Overlay title={`Gerenciar — ${modal.tenant.name}`}>
          <Field label="Nome"><input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></Field>
          <div style={{ display: 'flex', gap: 12 }}>
            <Field label="Plano" flex>
              <select style={styles.input} value={form.plan_id} onChange={e => setForm({ ...form, plan_id: e.target.value })}>
                <option value="">Sem plano</option>
                {plans.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </Field>
            <Field label="Status" flex>
              <select style={styles.input} value={form.subscription_status} onChange={e => setForm({ ...form, subscription_status: e.target.value })}>
                {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
            </Field>
          </div>
          <label style={styles.check}>
            <input type="checkbox" checked={!!form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked })} /> Empresa ativa
          </label>

          <div style={styles.divider}>Assinatura SaaS (a agência cobra a mensalidade via Asaas)</div>
          <SubscriptionBox tenant={modal.tenant} plans={plans} onDone={load} />

          <div style={styles.divider}>Gateways de pagamento (recebem dos clientes desta lan house)</div>
          <Field label="Mercado Pago — Access Token">
            <input style={styles.input} placeholder={Number(modal.tenant.has_mp) ? '•••• já configurado (deixe vazio p/ manter)' : 'cole o token aqui'}
              value={form.mp_access_token} onChange={e => setForm({ ...form, mp_access_token: e.target.value })} />
          </Field>
          <Field label="Asaas — API Key">
            <input style={styles.input} placeholder={Number(modal.tenant.has_asaas) ? '•••• já configurado (deixe vazio p/ manter)' : 'cole a chave aqui'}
              value={form.asaas_api_key} onChange={e => setForm({ ...form, asaas_api_key: e.target.value })} />
          </Field>
          <Actions onCancel={() => setModal(null)} onSave={handleUpdate} loading={loading} label="Salvar" />
        </Overlay>
      )}
    </div>
  );
}

function SubscriptionBox({ tenant, plans, onDone }) {
  const [info, setInfo] = useState(null);
  const [form, setForm] = useState({ email: '', cpfCnpj: '', mobilePhone: '', billingType: 'PIX' });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const plan = plans.find(p => String(p.id) === String(tenant.plan_id));

  useEffect(() => {
    if (Number(tenant.has_subscription)) {
      adminService.getSubscription(tenant.id)
        .then(r => setInfo(r.data))
        .catch(() => setInfo({ has_subscription: true, status: tenant.subscription_status }));
    } else setInfo({ has_subscription: false });
  }, [tenant.id, tenant.has_subscription, tenant.subscription_status]);

  const create = async () => {
    if (!form.email || !form.cpfCnpj) { setMsg('E-mail e CPF/CNPJ são obrigatórios'); return; }
    setBusy(true); setMsg('');
    try {
      const r = await adminService.createSubscription(tenant.id, form);
      setInfo({ has_subscription: true, status: 'active', next_due: r.data.next_due });
      setMsg('Assinatura criada ✓'); onDone && onDone();
    } catch (err) { setMsg(err.response?.data?.error || err.message); }
    finally { setBusy(false); }
  };
  const cancel = async () => {
    if (!window.confirm('Cancelar a assinatura desta empresa no Asaas?')) return;
    setBusy(true); setMsg('');
    try { await adminService.cancelSubscription(tenant.id); setInfo({ has_subscription: false }); onDone && onDone(); }
    catch (err) { setMsg(err.response?.data?.error || err.message); }
    finally { setBusy(false); }
  };

  const COLOR = { active: '#22c55e', past_due: '#f59e0b', canceled: '#ef4444', trial: '#60a5fa' };

  return (
    <div style={{ background: '#0e0e16', border: '1px solid #262636', borderRadius: 10, padding: 14, marginBottom: 4 }}>
      {!info && <div style={{ color: '#6b7280', fontSize: 13 }}>Carregando…</div>}

      {info && info.has_subscription && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div style={{ fontSize: 14 }}>Status: <b style={{ color: COLOR[info.status] || '#9ca3af' }}>{(STATUS[info.status] || info.status || '').toUpperCase()}</b></div>
          {info.next_due && <div style={{ color: '#9ca3af', fontSize: 13 }}>Próximo vencimento: <b style={{ color: '#e5e7eb' }}>{info.next_due}</b></div>}
          {info.value != null && <div style={{ color: '#9ca3af', fontSize: 13 }}>Valor: <b style={{ color: '#bef264' }}>R$ {Number(info.value).toFixed(2)}/mês</b></div>}
          <button style={{ ...styles.btnGhost, color: '#f87171', borderColor: '#7f1d1d', alignSelf: 'flex-start', marginTop: 4 }} onClick={cancel} disabled={busy}>Cancelar assinatura</button>
        </div>
      )}

      {info && !info.has_subscription && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ color: '#9ca3af', fontSize: 13 }}>
            Plano: {plan ? <b style={{ color: '#bef264' }}>{plan.name} — R$ {Number(plan.price_monthly).toFixed(2)}/mês</b> : <span style={{ color: '#f59e0b' }}>defina um plano com preço e salve</span>}
          </div>
          <input style={styles.input} placeholder="E-mail do responsável *" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          <input style={styles.input} placeholder="CPF ou CNPJ *" value={form.cpfCnpj} onChange={e => setForm({ ...form, cpfCnpj: e.target.value })} />
          <input style={styles.input} placeholder="Celular (opcional)" value={form.mobilePhone} onChange={e => setForm({ ...form, mobilePhone: e.target.value })} />
          <select style={styles.input} value={form.billingType} onChange={e => setForm({ ...form, billingType: e.target.value })}>
            <option value="PIX">PIX</option>
            <option value="BOLETO">Boleto</option>
            <option value="UNDEFINED">Cliente escolhe (PIX/Boleto/Cartão)</option>
          </select>
          <button style={{ ...styles.btnPrimary, alignSelf: 'flex-start' }} onClick={create} disabled={busy || !plan}>
            {busy ? 'Gerando…' : '💳 Gerar assinatura mensal'}
          </button>
        </div>
      )}

      {msg && <div style={{ color: msg.includes('✓') ? '#22c55e' : '#f87171', fontSize: 13, marginTop: 8 }}>{msg}</div>}
    </div>
  );
}

function Overlay({ title, children }) {
  return <div style={styles.overlay}><div style={styles.modal}><h2 style={styles.modalTitle}>{title}</h2>{children}</div></div>;
}
function Field({ label, children, flex }) {
  return <div style={{ marginBottom: 14, ...(flex ? { flex: 1 } : {}) }}><label style={styles.label}>{label}</label>{children}</div>;
}
function Actions({ onCancel, onSave, loading, label }) {
  return <div style={styles.modalActions}>
    <button style={styles.btnGhost} onClick={onCancel}>Cancelar</button>
    <button style={styles.btnPrimary} onClick={onSave} disabled={loading}>{loading ? '...' : label}</button>
  </div>;
}

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 20 },
  title: { color: '#fff', fontSize: 24, fontWeight: 700, margin: 0 },
  sub: { color: '#6b7280', fontSize: 14, margin: '4px 0 0' },
  btnPrimary: { padding: '10px 18px', background: 'var(--accent)', color: '#0a0a0f', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 },
  card: { background: '#14141f', border: '1px solid #262636', borderRadius: 12, padding: 18, display: 'flex', flexDirection: 'column', gap: 10 },
  cardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
  name: { color: '#fff', fontWeight: 700, fontSize: 17 },
  slug: { color: '#6b7280', fontSize: 12, marginTop: 2 },
  status: { fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 20, border: '1px solid' },
  planRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' },
  plan: { color: '#bef264', fontWeight: 600, fontSize: 14 },
  price: { color: '#9ca3af', fontSize: 13 },
  metaRow: { display: 'flex', gap: 14, color: '#9ca3af', fontSize: 13 },
  gateways: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  gwBadge: { fontSize: 11, fontWeight: 600, padding: '3px 8px', borderRadius: 6 },
  gwOn: { background: '#052e16', color: '#4ade80' },
  gwOff: { background: '#262636', color: '#6b7280' },
  inactive: { fontSize: 11, fontWeight: 600, padding: '3px 8px', borderRadius: 6, background: '#450a0a', color: '#f87171' },
  btnGhost: { padding: '9px 12px', background: 'transparent', border: '1px solid #374151', borderRadius: 8, color: '#bef264', cursor: 'pointer', fontSize: 13, fontWeight: 600, marginTop: 4 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#14141f', border: '1px solid #262636', borderRadius: 16, padding: 28, width: 460, maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto' },
  modalTitle: { color: '#fff', fontSize: 20, fontWeight: 700, margin: '0 0 20px' },
  divider: { color: '#6b7280', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, margin: '8px 0 14px', borderTop: '1px solid #262636', paddingTop: 14 },
  label: { display: 'block', color: '#9ca3af', fontSize: 13, fontWeight: 500, marginBottom: 6 },
  input: { width: '100%', padding: '10px 12px', background: '#1c1c2b', border: '1px solid #34344e', borderRadius: 8, color: '#fff', fontSize: 14, boxSizing: 'border-box' },
  check: { display: 'flex', alignItems: 'center', gap: 8, color: '#e5e7eb', fontSize: 14, marginBottom: 8, cursor: 'pointer' },
  modalActions: { display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 20 },
};
